import { render, staticRenderFns } from "./TaskUpload.vue?vue&type=template&id=052e83f0&"
import script from "./TaskUpload.vue?vue&type=script&lang=js&"
export * from "./TaskUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports